import OverviewStats from "@/pages/overview/overview-stats";
import OverviewCharts from "@/pages/overview/overview-charts";
import RecentActivity from "@/pages/overview/recent-activity";

/** Home page: summary PnL cards + sparkline charts + recent activity. */
export default function HomePage() {
  return (
    <>
      <OverviewStats />
      <OverviewCharts />
      <RecentActivity />
    </>
  );
}
